// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding-top: 160px; 
  background: linear-gradient(to bottom, black , #126196);
  color: #6C757D;
  font-family: Arial, sans-serif;
  padding-left: 10%;
  padding-right: 10%;
}

.list {
  width: 100%; 
  background-color: rgba(0, 0, 0, 0.25);
  box-shadow: none;
  padding: 1rem 2rem; 
  z-index: 1000; 
  border-radius: 10px; 
  transition: background-color 0.3s ease;
  color : white;
  font-size: large;
}

h2 {
  color: #01B9F1; 
}

.intro {
  color: rgba(255, 255, 255);
  text-align: center;
  font-size: x-large;
  padding-top: 30px; 
  padding-left: 10%; 
  padding-right: 10%; 
}

ol li {
  text-align: left;
  margin-bottom: 10px;
}

.carousel {
  margin-top: 30px;
}

.title {
  align-items: center;
}

.carousel img {
  width: 100%;
  height: 40vh; 
  object-fit: cover;
}


/* Responsive Styles */
@media (max-width: 700px) {
  body {
    padding-left: 5%; 
    padding-right: 5%; 

  }

  .list {
    padding: 1rem; 
  }

  h2 {
    font-size: 1.5rem;
  }

  .intro {
    font-size: large; 
    padding-left: 5%;
    padding-right: 5%;
  }
}

@media (max-width: 480px) {
  body {
    padding-left: 10px;
    padding-right: 10px; 
  }

  .list {
    padding: 0.5rem;
  }

  h2 {
    font-size: 1.25rem; 
  }

  .intro, ol {
    font-size: medium;
    padding-top: 10px; 
  }
}

.button-container {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.button {
  background-color: #01B9F1; 
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: large;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  margin: 0 10px; /* Space between the buttons */
}

.button:hover {
  background-color: #009dcf; /* Darker shade on hover */
  transform: scale(1.05); /* Slightly larger on hover */
}`, "",{"version":3,"sources":["webpack://./src/components/EloScoringPlatform.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,kBAAkB;EAClB,uDAAuD;EACvD,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;;AAGA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,iBAAiB;;EAEnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2DAA2D;EAC3D,wCAAwC;EACxC,cAAc,EAAE,8BAA8B;AAChD;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,sBAAsB,EAAE,6BAA6B;AACvD","sourcesContent":["body {\n  margin: 0;\n  padding-top: 160px; \n  background: linear-gradient(to bottom, black , #126196);\n  color: #6C757D;\n  font-family: Arial, sans-serif;\n  padding-left: 10%;\n  padding-right: 10%;\n}\n\n.list {\n  width: 100%; \n  background-color: rgba(0, 0, 0, 0.25);\n  box-shadow: none;\n  padding: 1rem 2rem; \n  z-index: 1000; \n  border-radius: 10px; \n  transition: background-color 0.3s ease;\n  color : white;\n  font-size: large;\n}\n\nh2 {\n  color: #01B9F1; \n}\n\n.intro {\n  color: rgba(255, 255, 255);\n  text-align: center;\n  font-size: x-large;\n  padding-top: 30px; \n  padding-left: 10%; \n  padding-right: 10%; \n}\n\nol li {\n  text-align: left;\n  margin-bottom: 10px;\n}\n\n.carousel {\n  margin-top: 30px;\n}\n\n.title {\n  align-items: center;\n}\n\n.carousel img {\n  width: 100%;\n  height: 40vh; \n  object-fit: cover;\n}\n\n\n/* Responsive Styles */\n@media (max-width: 700px) {\n  body {\n    padding-left: 5%; \n    padding-right: 5%; \n\n  }\n\n  .list {\n    padding: 1rem; \n  }\n\n  h2 {\n    font-size: 1.5rem;\n  }\n\n  .intro {\n    font-size: large; \n    padding-left: 5%;\n    padding-right: 5%;\n  }\n}\n\n@media (max-width: 480px) {\n  body {\n    padding-left: 10px;\n    padding-right: 10px; \n  }\n\n  .list {\n    padding: 0.5rem;\n  }\n\n  h2 {\n    font-size: 1.25rem; \n  }\n\n  .intro, ol {\n    font-size: medium;\n    padding-top: 10px; \n  }\n}\n\n.button-container {\n  display: flex;\n  justify-content: center;\n  margin: 20px 0;\n}\n\n.button {\n  background-color: #01B9F1; \n  color: white;\n  border: none;\n  border-radius: 5px;\n  padding: 10px 20px;\n  font-size: large;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n  margin: 0 10px; /* Space between the buttons */\n}\n\n.button:hover {\n  background-color: #009dcf; /* Darker shade on hover */\n  transform: scale(1.05); /* Slightly larger on hover */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
